import httpApi from '../api/httpApi';
import useSWR from 'swr';
import { MaxPrice } from '../../models/CollectionFilter';

const FILTER_URL = '/api/v1/products/max-price';

const useMaxPriceSWR = (filter: MaxPrice) => {
    const fetch = (query, filter): Promise<string> => {
        return httpApi
            .post<{ max: string }>(query, filter)
            .then((res) => {
                return res.getData().max;
            })
            .catch((error) => {
                throw error;
            });
    };

    const { data, error, isLoading, mutate } = useSWR(
        [FILTER_URL, filter],
        ([url, filter]) => fetch(url, filter),
        {
            dedupingInterval: 600000, // 10min
            errorRetryCount: 3,
        }
    );

    return {
        maxPrice: data ? data : null,
        isLoading: isLoading,
        isError: error,
        forceRefresh: mutate,
    };
};

export default useMaxPriceSWR;
